import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form/immutable';
import FlatButton from 'material-ui/FlatButton';

import { showDialog, hideDialog, showWarning } from '../../actions/dialogs';
import { toArray } from '../../utils/helper';
import { renderCreateJobResources } from '../../utils/reduxforms';
import validate from './validate';

class Page3 extends React.Component {
  static propTypes = {
    roles: PropTypes.array.isRequired,
    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    showWarning: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  state = {};

  render() {
    const { handleSubmit } = this.props;

    return (<form onSubmit={handleSubmit}>
      <Field
        name="resources"
        component={renderCreateJobResources}
      />
    </form>);
  }
}

const form = reduxForm({
  form: 'wizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubccess', result);
    console.log('dispatch', dispatch);
    // console.log('result.payload.toJS()', result.payload.toJS());

    const context = {
      type: 'warning',
      title: 'Upload Tasks?',
      message: 'Would you like to upload tasks now?',
      buttons: [
        <FlatButton
          label="No"
          onClick={() => props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Yes"
          onClick={() => {
            props.hideDialog('confirm');
            props.showDialog('taskUpload');
          }}
        />,
      ],
    };

    props.showDialog('confirm', context);
    props.onRequestClose();
  },
})(Page3);

function mapStateToProps(state) {
  return {
    roles: toArray(state.get('roles').get('roles').toJS()),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    showWarning,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/CreateJobDialog/Page3.js